import React from 'react';
import './SuggestionChips.css';

function SuggestionChips({ onSuggestionClick, show }) {
  if (!show) return null;

  const suggestions = [
    {
      text: 'Termin vereinbaren',
      query: 'Ich möchte einen Termin mit Philipp vereinbaren'
    },
    {
      text: 'Lebenslauf anzeigen',
      query: 'Zeige mir den Lebenslauf von Philipp'
    },
    {
      text: 'LLM-Expertise',
      query: 'Erzähle mir was über Philipps Wissen zu LLMs'
    },
    {
      text: 'Projekte',
      query: 'Welche Projekte hat Philipp umgesetzt?'
    }
  ];

  return (
    <div className="suggestion-chips-container">
      <p className="suggestion-chips-label">Vorschläge:</p>
      <div className="suggestion-chips">
        {suggestions.map((suggestion, index) => (
          <button
            key={index}
            className="suggestion-chip"
            onClick={() => onSuggestionClick(suggestion.query)}
          >
            <svg className="chip-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span className="chip-text">{suggestion.text}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default SuggestionChips;
